export var ACCEPTED_FILE_MIME_TYPES = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif',
];
//# sourceMappingURL=constants.js.map